import { ActionButton } from "./actionButton";
import { WebSocketManager } from "../../../helpers/webSocketManager";

export class WaitingListBtn extends ActionButton {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param texture {string}
   * @param serverEventAddress {string}
   * @param gameObj {Phaser.GameObjects.Image}
   */
  constructor(scene, table, texture, serverEventAddress, gameObj) {
    super(scene, table, texture, serverEventAddress, false, gameObj);
  }
  async onClick() {
    if (this.scene.isSceneObjectsInteractive) {
      await this.onClickTween();
      this.btnClicked = false;
      const data = {
        tableId: this.table.tableInfo.id,
        clubId: this.scene.getURLClubId(),
      };
      this.disableInteractive();
      let timeout = setTimeout(() => {
        this.enableInteractive();
      }, 3000);
      WebSocketManager.emitEvent(data, this.serverEventAddress)
        .then(() => {
          this.table.buttonManager.updateWaitingList();
          this.hide();
        })
        .finally(() => {
          this.enableInteractive();
          clearTimeout(timeout);
          timeout = null;
        });
    }
  }
}
